
import "../common/Focusable/Focusable.st.css.js";

import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_223_0_FillButton";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_223_0_FillButton__root","proportion":"wds_1_223_0_FillButton__proportion"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-color-border-transparent-primary":"--wds-color-border-transparent-primary","wds-color-fill-dark-primary-disabled":"--wds-color-fill-dark-primary-disabled","wds-color-fill-standard-secondary-disabled":"--wds-color-fill-standard-secondary-disabled","wds-color-fill-standard-secondary-hover":"--wds-color-fill-standard-secondary-hover","wds-color-fill-standard-secondary":"--wds-color-fill-standard-secondary","wds-color-text-primary":"--wds-color-text-primary","wds-color-text-disabled":"--wds-color-text-disabled","wds-color-text-standard-primary-light":"--wds-color-text-standard-primary-light","wds-shadow-focus-standard":"--wds-shadow-focus-standard","wds-swatches-swatch-border-radius-medium":"--wds-swatches-swatch-border-radius-medium","wds-swatches-swatch-size-tiny":"--wds-swatches-swatch-size-tiny","wds-fill-button-fill":"--wds-fill-button-fill","wds-fill-button-fill-hover":"--wds-fill-button-fill-hover","wds-fill-button-icon-color":"--wds-fill-button-icon-color","wds-fill-button-border-width":"--wds-fill-button-border-width","wds-fill-button-border-color":"--wds-fill-button-border-color","backgroundColor":"--wds_1_223_0_FillButton-backgroundColor"}; 




